import { createContext } from 'react';

const UserSessionValuesContext = createContext({
  user: {
    created: () => true,
  },
  backToShelfInfo: {},
});

export default UserSessionValuesContext;
